import { makeStyles } from '@material-ui/core';
// import { themeColor } from '../../../mui-theme';

export const stylesRewardsButtons = makeStyles(theme => ({
  icon: {
    marginRight: '0.5vw',
    color: theme.palette.secondary.main,
    fill: theme.palette.secondary.main,
    height: '2.34vh',
    width: 'auto',
  },
}));
